import React, { useState } from 'react';
import './ColorSelect.scss';
import { vehicleColors } from '../../data';

const ColorSelect = ({ value, onChange, error,label = "Couleur" ,setShowOtherColor}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedColor = vehicleColors.find(color => color.value === value) || vehicleColors[0];

  return (
    <div className="color-select-container">
      {/* <label className="color-select-label">{label}</label> */}
      <div className="color-select-wrapper">
        <div 
          className="color-select-trigger" 
          onClick={() => setIsOpen(!isOpen)}
          style={{ borderColor: isOpen ? '#2a7de1' : '#ddd' }}
        >
          <div className="color-preview" style={{ backgroundColor: selectedColor.hex }} />
          <span>{selectedColor.label}</span>
          <svg 
            className={`dropdown-icon ${isOpen ? 'open' : ''}`} 
            viewBox="0 0 24 24"
          >
            <path d="M7 10l5 5 5-5z" />
          </svg>
        </div>
        
        {isOpen && (
          <div className="color-options-dropdown">
            {vehicleColors.map((color) => (
              <div
                key={color.value}
                className={`color-option ${value === color.value ? 'selected' : ''}`}
                onClick={() => {
                  onChange(color.value);
                  setIsOpen(false);
                  setShowOtherColor(color.value === "autre");
                }}
              >
                <div 
                  className="color-preview" 
                  style={{ backgroundColor: color.hex }}
                />
                <span>{color.label}</span>
              </div>
            ))}
            {error && <span className="error-msg">{error.message}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

export default ColorSelect;